module.exports = __webpack_public_path__ + "img/20190722165144QQ截图20190722093809.2effae1f.png";